import {forwardRef, useState} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import DisplayModal from '../DisplayModal';
import TermsAndConditions from '../TermsAndConditions';

/**
 * "I have read and agree to the Terms of Service and the Privacy Policy." checkbox. As in the
 * legacy app, "Terms of Service" opens the terms in a dialog and "Privacy Policy" goes to
 * /privacy. The whole sentence is the checkbox's label.
 */
const TermsAgreement = forwardRef(function TermsAgreement(
  {id, checked, onChange, invalid, describedBy},
  ref,
) {
  const [termsOpen, setTermsOpen] = useState(false);
  return (
    <div className="auth-terms">
      <input
        ref={ref}
        id={id}
        type="checkbox"
        className="auth-terms-box"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        aria-invalid={invalid ? 'true' : undefined}
        aria-describedby={describedBy || undefined}
        data-testid="terms-checkbox"
      />
      <label htmlFor={id} className="auth-terms-text">
        I have read and agree to the{' '}
        <a
          href="#terms-of-service"
          className="auth-link"
          aria-haspopup="dialog"
          onClick={(e) => {
            e.preventDefault();
            setTermsOpen(true);
          }}
        >
          Terms of Service
        </a>{' '}
        and the{' '}
        <Link to="/privacy" className="auth-link">
          Privacy Policy
        </Link>
        .
      </label>
      <DisplayModal
        show={termsOpen}
        onHide={() => setTermsOpen(false)}
        title="Terms and Conditions of Usage of our Website and Mobile Application"
      >
        <div className="auth-terms-scroll" role="region" aria-label="Terms of Service text" tabIndex={0}>
          <TermsAndConditions />
        </div>
      </DisplayModal>
    </div>
  );
});

TermsAgreement.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  invalid: PropTypes.bool,
  describedBy: PropTypes.string,
};

export default TermsAgreement;
